export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50/40">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-56 h-56 md:w-64 md:h-64 rounded-3xl overflow-hidden bg-background-200 border-4 border-background-50">
            <img
              src="https://readdy.ai/api/search-image?query=Mobile%20phone%20displaying%20movie%20streaming%20app%20interface%20with%20warm%20cinematic%20color%20scheme%2C%20film%20posters%20grid%20on%20screen%2C%20modern%20UI%20design%2C%20cozy%20ambient%20lighting%2C%20clean%20minimal%20aesthetic%2C%20warm%20golden%20and%20red%20accents%2C%20app%20store%20style%20presentation&width=500&height=500&seq=app-section-2026&orientation=squarish"
              alt="番茄影视大全移动端随时随地看大片"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">随时随地 · 手机观影</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              番茄影视大全移动端适配完美，支持手机浏览器直接访问。无需下载App，打开网页即可畅享高清观影体验。公交地铁、午休时间、睡前放松，随时随地追剧看电影，精彩不错过。
            </p>
            <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start">
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 border border-background-200">
                <i className="ri-smartphone-line text-primary-600 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700">手机浏览器即开即看</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 border border-background-200">
                <i className="ri-wifi-line text-accent-600 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700">流量消耗低</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 border border-background-200">
                <i className="ri-fullscreen-line text-primary-600 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700">全屏沉浸观影</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}